/* eslint-disable */ 
import React, { PureComponent } from 'react';
import './style.css';

class Watermark extends PureComponent {

    render() {

        if (this.props.logoURL) {

            var logoSize, wtLogoSize;
            if (this.props.page === 'entry') {
                logoSize = '140px'; // eslint-disable-line no-unused-vars
                wtLogoSize = '120px';

            } else if (this.props.page === 'report') {
                logoSize = '80px'; // eslint-disable-line no-unused-vars
                wtLogoSize = '70px';
            }

            return (
                <div>
                    <div className={this.props.page + 'page'}>
                        
                        <span className='clientlogo'>
                            <img src={this.props.logoURL} width={logoSize} alt='WT logo' />
                        </span>
                       

                        <span className='wtlogo' onClick={() => { window.open('https://www.wisdomtree.com/advisor-solutions/portfolio-construction-services', '_blank') }}>
                            <span className='subtitle'>Powered by </span>
                            <img src='https://www.wisdomtree.com/-/media/base-media-files/header/logo.ashx' width={wtLogoSize} alt='WT logo' />
                        </span>
                    </div>
                </div>
            );

        }

        return null;

    }
}

export default Watermark;



// WEBPACK FOOTER //
// ./src/components/Watermark/index.js